import ConfigService from '../index'
// import CustomRequestException from '../../exceptions/CustomRequestException'
class UserService extends ConfigService {
    constructor(){
        super('rh/api/v1/')
    }
}
export default UserService
